/**
 * KF analytics events
 *
 * Publishes the site's GA4 conversion events to Shopify's Customer Events
 * bus with Shopify.analytics.publish(). A custom pixel (Settings > Customer
 * events > "KF GA4 events") subscribes to these names and forwards them to
 * GA4, so they respect the visitor's cookie consent like every other pixel.
 *
 * Events
 *   newsletter_sign_up  a newsletter form rendered its success message
 *                       { form_location: footer_band | footer | popup }
 *   form_submission     the contact form rendered its success message
 *                       { form_name: <page handle>, e.g. contact }
 *   contact_page_view   the Contact page loaded
 *   email_link_click    a mailto: link was clicked   { link_location }
 *   phone_link_click    a tel: link was clicked      { link_location }
 *
 * Form events are driven by markers the Liquid renders only in a form's
 * success branch (snippets/analytics-event.liquid), so they count completed
 * submissions, not clicks on Submit. A refresh of the success page would
 * render the marker again; sessionStorage keeps that from counting twice.
 */
(() => {
  if (window.__kfAnalyticsEvents) return;
  window.__kfAnalyticsEvents = true;

  const publish = (name, data = {}) => {
    const analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    try {
      analytics.publish(name, data);
    } catch (error) {
      // Analytics must never break the page.
    }
  };

  const alreadySent = (key) => {
    try {
      if (sessionStorage.getItem(key)) return true;
      sessionStorage.setItem(key, '1');
    } catch (error) {
      // Storage blocked: send anyway rather than lose the event.
    }
    return false;
  };

  const parseParams = (raw) => {
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (error) {
      return {};
    }
  };

  const flushMarkers = () => {
    document.querySelectorAll('template[data-kf-event]').forEach((marker) => {
      const name = marker.dataset.kfEvent;
      const params = parseParams(marker.dataset.kfParams);
      const once = marker.dataset.kfOnce === 'true';
      if (once && alreadySent(`kf-event:${name}:${location.pathname}${location.search}`)) return;
      publish(name, params);
    });
  };

  // Where on the page a link sits, for the click events.
  const linkLocation = (link) => {
    if (link.closest('header, .header')) return 'header';
    if (link.closest('footer, .footer, [id*="footer"]')) return 'footer';
    return 'content';
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    const href = (link.getAttribute('href') || '').trim().toLowerCase();
    if (href.startsWith('mailto:')) {
      publish('email_link_click', { link_location: linkLocation(link) });
    } else if (href.startsWith('tel:')) {
      publish('phone_link_click', { link_location: linkLocation(link) });
    }
  }, { capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flushMarkers);
  } else {
    flushMarkers();
  }
})();
